import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';

import AssetFeed from 'components/assetFeed/AssetFeed';
import { graphQLIdFromProjectDBID } from 'helpers/graphql-utils';
import TaskAssetFooter from 'components/projects/taskList/components/TaskAssetFooter';
import TaskPhotoUploadModal from 'components/projects/taskList/TaskPhotoUploadModal';

// #region styled-components

const AssetFeedContainer = styled.div`
  padding: 0 var(--cc_size_spacing_xl);
`;

const messages = defineMessages({
  taskAddProjectPhotos: {
    id: 'Projects.taskList.taskAssetsModal.taskAddProjectPhotos',
    defaultMessage: 'Add Photos From Project',
    description: 'Title that appears when adding a photo to a task',
  },
});

const TaskAssetsModal = ({ isOpen, onRequestClose, taskId }) => {
  const intl = useIntl();
  const { id } = useParams();
  const projectNodeId = graphQLIdFromProjectDBID(id);
  const [isTaskAssetUploadOpen, setIsTaskAssetUploadOpen] = useState(false);

  const uploadPhotoOption = () => {
    setIsTaskAssetUploadOpen(true);
    onRequestClose();
  };

  const assetFilters = {
    assetType: 'PHOTOS_ONLY',
    capturedAfter: null,
    capturedBefore: null,
    users: [],
    groups: [],
    projects: [],
    tags: [],
  };

  return (
    <>
      <CCModal
        isOpen={isOpen}
        size="large"
        showCloseButton
        onRequestClose={onRequestClose}
        title={intl.formatMessage(messages.taskAddProjectPhotos)}
        headerStyle={{ borderBottomWidth: 0 }}
        bodyStyle={{ padding: 0, overFlow: 'hidden' }}
        label="Assets"
      >
        <AssetFeedContainer>
          <AssetFeed
            entityId={projectNodeId}
            multiSelectHandlerComponent={
              <TaskAssetFooter
                taskId={taskId}
                onRequestClose={onRequestClose}
                uploadPhotoOption={uploadPhotoOption}
              />
            }
            isPresentedInModal
            enableTopControls={false}
            initialFilters={assetFilters}
          />
        </AssetFeedContainer>
      </CCModal>
      <TaskPhotoUploadModal
        isOpen={isTaskAssetUploadOpen}
        onRequestClose={() => setIsTaskAssetUploadOpen(false)}
        taskId={taskId}
      />
    </>
  );
};

TaskAssetsModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  taskId: PropTypes.string,
};

export default TaskAssetsModal;
